/* ==========================================================================
   CORIANNE STUDIO — interacciones propias
   Todo vanilla, sin librerias externas. Cada init comprueba que su elemento
   existe, asi el mismo archivo sirve para todas las paginas.
   ========================================================================== */

(function () {
  'use strict';

  var sinMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- Animaciones de entrada al hacer scroll --------------------------- */

  function initReveals(raiz) {
    var elementos = (raiz || document).querySelectorAll('.mt-reveal, .mt-reveal-img');
    if (!elementos.length) return;

    if (sinMovimiento || !('IntersectionObserver' in window)) {
      elementos.forEach(function (el) {
        el.classList.add('mt-visible');
      });
      return;
    }

    // A partir de aqui SI vamos a animar, asi que activamos el estado oculto
    // inicial. El CSS lo tiene detras de `.mt-anim` justamente para esto: si
    // este guion no llega a ejecutarse, las fotos se ven igual. Antes nacian
    // ocultas siempre y una foto invisible dependia de que el JS respondiera.
    document.documentElement.classList.add('mt-anim');

    var observador = new IntersectionObserver(
      function (entradas) {
        entradas.forEach(function (entrada) {
          if (!entrada.isIntersecting) return;
          entrada.target.classList.add('mt-visible');
          observador.unobserve(entrada.target);
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );

    elementos.forEach(function (el) {
      observador.observe(el);
    });

    // Red de seguridad. El observador falla de vez en cuando en moviles con
    // elementos que llevan clip-path, y entonces la foto se queda al 100% de
    // recorte, es decir, invisible. Repasamos por nuestra cuenta lo que ya
    // deberia estar a la vista. Si el observador va bien, esto no hace nada
    // porque las encuentra todas marcadas.
    function repasar() {
      var quedan = false;
      elementos.forEach(function (el) {
        if (el.classList.contains('mt-visible')) return;
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) {
          el.classList.add('mt-visible');
          observador.unobserve(el);
        } else {
          quedan = true;
        }
      });
      return quedan;
    }

    var ultimoRepaso = 0;
    function alScroll() {
      if (Date.now() - ultimoRepaso < 200) return;
      ultimoRepaso = Date.now();
      if (!repasar()) window.removeEventListener('scroll', alScroll);
    }

    window.addEventListener('scroll', alScroll, { passive: true });
    window.addEventListener('resize', alScroll, { passive: true });
    // Y un repaso a los 2 s para la primera pantalla, por si el usuario no
    // llega a desplazarse.
    setTimeout(repasar, 2000);
  }

  /* --- Parallax suave del hero ------------------------------------------ */

  function initParallax() {
    var medias = document.querySelectorAll('[data-mt-parallax]');
    if (!medias.length || sinMovimiento) return;

    var pendiente = false;

    function pintar() {
      pendiente = false;
      var scroll = window.pageYOffset;
      medias.forEach(function (media) {
        var seccion = media.closest('.mt-hero');
        if (!seccion) return;
        var caja = seccion.getBoundingClientRect();
        if (caja.bottom < 0 || caja.top > window.innerHeight) return;
        var fuerza = parseFloat(media.getAttribute('data-mt-parallax')) || 0;
        if (!fuerza) return;
        var desplazamiento = (scroll - (seccion.offsetTop || 0)) * (fuerza / 100);
        media.style.transform = 'translate3d(0,' + desplazamiento.toFixed(2) + 'px,0)';
      });
    }

    function alScroll() {
      if (pendiente) return;
      pendiente = true;
      window.requestAnimationFrame(pintar);
    }

    window.addEventListener('scroll', alScroll, { passive: true });
    window.addEventListener('resize', alScroll, { passive: true });
    pintar();
  }

  /* --- Marquesina infinita ---------------------------------------------- */
  /* Duplica la pista para que el bucle no tenga costura. */

  function initMarquesinas(raiz) {
    var wraps = (raiz || document).querySelectorAll('[data-mt-marquesina]');
    wraps.forEach(function (wrap) {
      if (wrap.dataset.mtListo === '1') return;
      var pista = wrap.querySelector('.mt-marquesina__pista, .mt-resenas__pista, .mt-anuncio__pista');
      if (!pista) return;
      var copia = pista.cloneNode(true);
      copia.setAttribute('aria-hidden', 'true');
      // La copia es decorativa: sus enlaces no deben poder recibir el foco,
      // o el tabulador pararia dos veces en el mismo sitio dentro de algo
      // marcado como oculto para los lectores de pantalla.
      copia.querySelectorAll('a').forEach(function (enlace) {
        enlace.setAttribute('tabindex', '-1');
      });
      pista.parentNode.appendChild(copia);
      wrap.dataset.mtListo = '1';
    });
  }

  /* --- FAQ (acordeon con altura animada) -------------------------------- */

  function initFaq(raiz) {
    var items = (raiz || document).querySelectorAll('.mt-faq__item');
    if (!items.length) return;

    items.forEach(function (item) {
      var boton = item.querySelector('.mt-faq__boton');
      var panel = item.querySelector('.mt-faq__panel');
      if (!boton || !panel || boton.dataset.mtListo === '1') return;
      boton.dataset.mtListo = '1';

      boton.addEventListener('click', function () {
        var abierto = item.classList.contains('is-abierto');
        var lista = item.closest('.mt-faq__lista');

        // Cierra los hermanos (acordeon de uno en uno)
        if (lista && !abierto) {
          lista.querySelectorAll('.mt-faq__item.is-abierto').forEach(function (otro) {
            otro.classList.remove('is-abierto');
            var p = otro.querySelector('.mt-faq__panel');
            var b = otro.querySelector('.mt-faq__boton');
            if (p) p.style.height = '0px';
            if (b) b.setAttribute('aria-expanded', 'false');
          });
        }

        if (abierto) {
          item.classList.remove('is-abierto');
          panel.style.height = '0px';
          boton.setAttribute('aria-expanded', 'false');
        } else {
          item.classList.add('is-abierto');
          var inner = panel.firstElementChild;
          panel.style.height = (inner ? inner.offsetHeight : 0) + 'px';
          boton.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  /* --- Galeria de producto ---------------------------------------------- */

  /* Cambia la foto grande con una fundida suave. Precarga la nueva imagen
     antes de intercambiarla para que no se vea el hueco en blanco. */
  function cambiarFoto(img, src, srcset, alt) {
    if (!img || !src) return;
    if (sinMovimiento) {
      img.src = src;
      if (srcset) img.srcset = srcset;
      if (alt != null) img.alt = alt;
      return;
    }
    var previa = new Image();
    previa.onload = previa.onerror = function () {
      img.src = src;
      if (srcset) img.srcset = srcset;
      if (alt != null) img.alt = alt;
      img.classList.remove('is-cambiando');
    };
    img.classList.add('is-cambiando');
    previa.src = src;
  }

  /* Flechas de una galeria. Si el carrusel se puede desplazar (movil) las
     flechas deslizan; si no (ordenador), pasan de miniatura en miniatura. */
  function conectarFlechas(contenedor, selFlecha, carrusel, minis, contador) {
    var flechas = contenedor.querySelectorAll(selFlecha);
    if (!flechas.length) return;

    flechas.forEach(function (flecha) {
      if (flecha.dataset.mtListo === '1') return;
      flecha.dataset.mtListo = '1';

      flecha.addEventListener('click', function () {
        var dir = parseInt(flecha.getAttribute(selFlecha.slice(1, -1)), 10) || 1;

        if (carrusel && carrusel.scrollWidth > carrusel.clientWidth + 4) {
          var paso = carrusel.clientWidth;
          var tope = carrusel.scrollWidth - paso;
          var destino = Math.max(0, Math.min(tope, carrusel.scrollLeft + dir * paso));
          carrusel.scrollTo({
            left: destino,
            behavior: sinMovimiento ? 'auto' : 'smooth',
          });
          // El contador se pone a mano: el desplazamiento suave no siempre
          // dispara el evento de scroll a tiempo.
          if (contador && paso) {
            var total = carrusel.querySelectorAll('img').length;
            var pos = Math.round(destino / paso) + 1;
            contador.textContent = Math.min(pos, total) + '/' + total;
          }
          return;
        }

        if (!minis.length) return;
        var actual = 0;
        minis.forEach(function (m, i) {
          if (m.classList.contains('is-activa')) actual = i;
        });
        var siguiente = (actual + dir + minis.length) % minis.length;
        minis[siguiente].click();
        // Que la miniatura elegida quede a la vista si la tira se desliza.
        minis[siguiente].scrollIntoView({
          block: 'nearest',
          inline: 'nearest',
          behavior: sinMovimiento ? 'auto' : 'smooth',
        });
      });
    });
  }

  function initGaleria(raiz) {
    var galerias = (raiz || document).querySelectorAll('[data-mt-galeria]');
    galerias.forEach(function (galeria) {
      var principal = galeria.querySelector('[data-mt-galeria-principal]');
      var minis = galeria.querySelectorAll('[data-mt-galeria-mini]');

      // Contador del carrusel de movil ("3/8")
      var carrusel = galeria.querySelector('[data-mt-galeria-carrusel]');
      var contador = galeria.querySelector('[data-mt-galeria-contador]');
      if (carrusel && contador && carrusel.dataset.mtListo !== '1') {
        carrusel.dataset.mtListo = '1';
        var total = carrusel.querySelectorAll('img').length;
        carrusel.addEventListener(
          'scroll',
          function () {
            var i = Math.round(carrusel.scrollLeft / carrusel.clientWidth) + 1;
            contador.textContent = Math.min(i, total) + '/' + total;
          },
          { passive: true }
        );
      }

      if (!principal || !minis.length) return;

      minis.forEach(function (mini) {
        if (mini.dataset.mtListo === '1') return;
        mini.dataset.mtListo = '1';
        mini.addEventListener('click', function () {
          var src = mini.getAttribute('data-src');
          var srcset = mini.getAttribute('data-srcset');
          var alt = mini.getAttribute('data-alt') || '';
          if (!src || principal.getAttribute('src') === src) return;

          minis.forEach(function (m) {
            m.classList.remove('is-activa');
            m.setAttribute('aria-current', 'false');
          });
          mini.classList.add('is-activa');
          mini.setAttribute('aria-current', 'true');

          // Se precarga y luego se funde, para que no parpadee en blanco.
          cambiarFoto(principal, src, srcset, alt);
        });
      });

      conectarFlechas(galeria, '[data-mt-galeria-flecha]', carrusel, minis, contador);
    });
  }

  // Cambia la foto mostrada al color elegido en el selector de variantes.
  // Busca primero entre las miniaturas (ordenador); si la galeria es el
  // carrusel de movil, desliza hasta la foto de ese color en su lugar.
  function mostrarColorEnGaleria(seccion, colorLower) {
    if (!colorLower) return;
    var galeria = seccion.querySelector('[data-mt-galeria]');
    if (!galeria) return;

    var mini = null;
    galeria.querySelectorAll('[data-mt-galeria-mini]').forEach(function (m) {
      if (!mini && m.getAttribute('data-mt-color') === colorLower) mini = m;
    });
    if (mini && getComputedStyle(mini.parentElement).display !== 'none') {
      mini.click();
      return;
    }

    var carrusel = galeria.querySelector('[data-mt-galeria-carrusel]');
    if (!carrusel) return;
    var imgs = carrusel.querySelectorAll('img');
    var indice = -1;
    imgs.forEach(function (img, i) {
      if (indice === -1 && img.getAttribute('data-mt-color') === colorLower) indice = i;
    });
    if (indice === -1) return;
    carrusel.scrollTo({
      left: indice * carrusel.clientWidth,
      behavior: sinMovimiento ? 'auto' : 'smooth',
    });
  }

  /* --- Selector de variantes -------------------------------------------- */

  function initVariantes(raiz) {
    var bloques = (raiz || document).querySelectorAll('[data-mt-variantes]');
    bloques.forEach(function (bloque) {
      if (bloque.dataset.mtListo === '1') return;

      var datos = bloque.querySelector('[data-mt-variantes-json]');
      var inputId = bloque.querySelector('[data-mt-variant-id]');
      var boton = bloque.querySelector('[data-mt-boton]');
      var precio = bloque.querySelector('[data-mt-precio]');
      var precioAntes = bloque.querySelector('[data-mt-precio-antes]');
      var ahorro = bloque.querySelector('[data-mt-ahorro]');
      var stock = bloque.querySelector('[data-mt-stock]');
      var radios = bloque.querySelectorAll('[data-mt-opcion]');
      if (!datos || !inputId) return;
      bloque.dataset.mtListo = '1';

      var variantes;
      try {
        variantes = JSON.parse(datos.textContent);
      } catch (e) {
        return;
      }
      if (!variantes || !variantes.length) return;

      var textoComprar = boton ? boton.getAttribute('data-texto-comprar') : '';
      var textoAgotado = boton ? boton.getAttribute('data-texto-agotado') : '';
      var textoElegir = boton ? boton.getAttribute('data-texto-elegir') || '' : '';

      // Auditoria C-04: la talla ya no viene marcada de fabrica, asi que hay que
      // saber cuantos grupos de opcion existen para exigir que esten TODOS
      // elegidos. Sin esto, el buscador de variante casaba con la primera que
      // coincidiera solo en color, es decir, una talla al azar.
      var gruposOpcion = [];
      radios.forEach(function (r) {
        var idx = parseInt(r.getAttribute('data-mt-opcion'), 10);
        if (gruposOpcion.indexOf(idx) === -1) gruposOpcion.push(idx);
      });
      var escasez = bloque.querySelector('[data-mt-escasez]');
      var medidor = bloque.querySelector('[data-mt-escasez-medidor]');
      var stickyPrecio = document.querySelector('[data-mt-sticky] [data-mt-precio]');

      function textoBoton(el, texto) {
        // El boton lleva un <span> dentro para que la animacion de fondo
        // quede por debajo del texto.
        var span = el.querySelector('span');
        if (span) span.textContent = texto;
        else el.textContent = texto;
      }

      // Pinta el aviso de unidades restantes usando el stock REAL de Shopify.
      function pintarEscasez(v, tallaElegida) {
        if (!escasez) return;
        var umbral = parseInt(escasez.getAttribute('data-umbral'), 10) || 10;
        var etiqueta = escasez.querySelector('[data-mt-escasez-texto]');
        var talla = tallaElegida || '';
        var texto;

        escasez.classList.remove('mt-escasez--bajo', 'mt-escasez--no');
        if (medidor) medidor.hidden = true;

        if (!v || !v.available) {
          texto = escasez.getAttribute('data-texto-no');
          escasez.classList.add('mt-escasez--no');
        } else if (v.stock !== null && v.stock !== undefined && v.stock <= umbral) {
          texto = escasez.getAttribute('data-texto-bajo');
          escasez.classList.add('mt-escasez--bajo');
          if (medidor) {
            var barra = medidor.firstElementChild;
            var pct = Math.max(6, Math.round((v.stock / umbral) * 100));
            if (barra) barra.style.width = pct + '%';
            medidor.hidden = false;
          }
        } else {
          texto = escasez.getAttribute('data-texto-ok');
        }

        texto = (texto || '')
          .replace('[talla]', talla)
          .replace('[n]', v && v.stock != null ? v.stock : '');
        if (etiqueta) etiqueta.textContent = texto;
        escasez.hidden = texto === '';
      }

      function seleccionadas() {
        var elegidas = [];
        bloque.querySelectorAll('[data-mt-opcion]:checked').forEach(function (r) {
          elegidas[parseInt(r.getAttribute('data-mt-opcion'), 10)] = r.value;
        });
        return elegidas;
      }

      function actualizar() {
        var elegidas = seleccionadas();

        // Refresca la etiqueta junto al nombre de la opcion. Usamos el nombre
        // traducido que guarda la etiqueta, no el valor interno en ingles.
        bloque.querySelectorAll('[data-mt-opcion-valor]').forEach(function (span) {
          var i = parseInt(span.getAttribute('data-mt-opcion-valor'), 10);
          if (!elegidas[i]) return;
          var marcado = bloque.querySelector('[data-mt-opcion="' + i + '"]:checked');
          var etiqueta = marcado ? bloque.querySelector('label[for="' + marcado.id + '"]') : null;
          var visible = etiqueta && etiqueta.getAttribute('data-mt-nombre');
          span.textContent = visible || elegidas[i];
        });

        // Si hay un color elegido, cambia la foto de la galeria a ese color.
        var colorMarcado = bloque.querySelector('[data-mt-es-color]:checked');
        if (colorMarcado) {
          var etiquetaColor = bloque.querySelector('label[for="' + colorMarcado.id + '"]');
          var nombreColor = etiquetaColor && etiquetaColor.getAttribute('data-mt-nombre');
          var seccion = bloque.closest('.mt-producto');
          if (nombreColor && seccion) {
            mostrarColorEnGaleria(seccion, nombreColor.trim().toLowerCase());
          }
        }

        // Auditoria C-04: si falta alguna opcion por elegir (normalmente la
        // talla), no se resuelve ninguna variante. Se vacia el campo oculto para
        // que un envio del formulario no pueda colar una talla al azar.
        var faltaElegir = false;
        for (var g = 0; g < gruposOpcion.length; g++) {
          if (!elegidas[gruposOpcion[g]]) {
            faltaElegir = true;
            break;
          }
        }
        if (faltaElegir) {
          inputId.value = '';
          if (boton) {
            boton.disabled = true;
            textoBoton(boton, textoElegir || textoComprar);
          }
          pintarEscasez(null, '');
          return;
        }

        var encontrada = null;
        for (var i = 0; i < variantes.length; i++) {
          var v = variantes[i];
          var coincide = true;
          for (var j = 0; j < elegidas.length; j++) {
            if (elegidas[j] && v.options[j] !== elegidas[j]) {
              coincide = false;
              break;
            }
          }
          if (coincide) {
            encontrada = v;
            break;
          }
        }

        if (!encontrada) {
          if (boton) {
            boton.disabled = true;
            textoBoton(boton, textoAgotado);
          }
          pintarEscasez(null, elegidas[elegidas.length - 1]);
          return;
        }

        inputId.value = encontrada.id;

        // Los precios llegan ya formateados por Liquid (moneda de la tienda).
        if (precio) precio.textContent = encontrada.precio;
        if (stickyPrecio) stickyPrecio.textContent = encontrada.precio;

        // La talla suele ser la ultima opcion; si no hay, no se sustituye nada.
        pintarEscasez(encontrada, elegidas[elegidas.length - 1]);

        if (precioAntes) {
          if (encontrada.precio_antes) {
            precioAntes.textContent = encontrada.precio_antes;
            precioAntes.hidden = false;
            if (ahorro && encontrada.descuento) {
              ahorro.textContent = '-' + encontrada.descuento + '%';
              ahorro.hidden = false;
            }
          } else {
            precioAntes.hidden = true;
            if (ahorro) ahorro.hidden = true;
          }
        }

        if (boton) {
          boton.disabled = !encontrada.available;
          textoBoton(boton, encontrada.available ? textoComprar : textoAgotado);
        }

        if (stock) {
          var punto = stock.querySelector('.mt-compra__punto');
          var etiqueta = stock.querySelector('[data-mt-stock-texto]');
          if (punto) punto.classList.toggle('mt-compra__punto--no', !encontrada.available);
          if (etiqueta) {
            etiqueta.textContent = encontrada.available
              ? stock.getAttribute('data-texto-si')
              : stock.getAttribute('data-texto-no');
          }
        }

        // Actualiza la URL para que se pueda compartir la variante
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', encontrada.id);
          window.history.replaceState({}, '', url.toString());
        }
      }

      radios.forEach(function (radio) {
        radio.addEventListener('change', actualizar);
      });

      actualizar();
    });
  }

  /* --- Cantidad ---------------------------------------------------------- */

  function initCantidad(raiz) {
    var cajas = (raiz || document).querySelectorAll('[data-mt-cantidad]');
    cajas.forEach(function (caja) {
      if (caja.dataset.mtListo === '1') return;
      caja.dataset.mtListo = '1';
      var input = caja.querySelector('input');
      if (!input) return;
      caja.querySelectorAll('button').forEach(function (boton) {
        boton.addEventListener('click', function () {
          var paso = boton.getAttribute('data-mt-paso') === 'mas' ? 1 : -1;
          var valor = parseInt(input.value, 10) || 1;
          input.value = Math.max(1, valor + paso);
        });
      });
    });
  }

  /* --- Añadir al carrito sin recargar + reserva --------------------------- */
  /* La reserva es un temporizador REAL de la sesion del navegador: empieza
     cuando el producto entra de verdad en el carrito. */

  function initCompra(raiz) {
    var bloques = (raiz || document).querySelectorAll('[data-mt-producto]');
    bloques.forEach(function (bloque) {
      var form = bloque.querySelector('form[action*="/cart/add"]');
      var boton = bloque.querySelector('[data-mt-boton]');
      var reserva = bloque.querySelector('[data-mt-reserva]');
      if (!form || !boton || form.dataset.mtListo === '1') return;
      form.dataset.mtListo = '1';

      var textoComprar = boton.getAttribute('data-texto-comprar') || '';
      var textoAnadiendo = boton.getAttribute('data-texto-anadiendo') || '';
      var temporizador = null;

      function ponerTexto(texto) {
        var span = boton.querySelector('span');
        if (span) span.textContent = texto;
        else boton.textContent = texto;
      }

      function arrancarReserva() {
        if (!reserva) return;
        var minutos = parseInt(reserva.getAttribute('data-minutos'), 10) || 10;
        var plantilla = reserva.getAttribute('data-texto') || '';
        var textoFin = reserva.getAttribute('data-texto-fin') || '';
        var etiqueta = reserva.querySelector('[data-mt-reserva-texto]');
        var quedan = minutos * 60;

        reserva.classList.add('is-activa');
        if (temporizador) clearInterval(temporizador);

        function pintar() {
          if (quedan <= 0) {
            clearInterval(temporizador);
            temporizador = null;
            if (etiqueta) etiqueta.textContent = textoFin;
            return;
          }
          var m = Math.floor(quedan / 60);
          var sg = quedan % 60;
          var reloj = m + ':' + (sg < 10 ? '0' : '') + sg;
          if (etiqueta) etiqueta.textContent = plantilla.replace('[reloj]', reloj);
          quedan--;
        }

        pintar();
        temporizador = setInterval(pintar, 1000);
      }

      function refrescarContadorCarrito() {
        // Dawn pinta el numero del carrito en varios sitios; los actualizamos
        // sin recargar la pagina.
        fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (carrito) {
            document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"]').forEach(function (el) {
              el.textContent = carrito.item_count;
            });
            var burbuja = document.querySelector('.cart-count-bubble');
            if (burbuja) burbuja.hidden = carrito.item_count === 0;
            document.dispatchEvent(new CustomEvent('mt:carrito', { detail: carrito }));
          })
          .catch(function () {});
      }

      form.addEventListener('submit', function (evento) {
        if (boton.disabled) return;
        evento.preventDefault();

        boton.disabled = true;
        ponerTexto(textoAnadiendo || textoComprar);

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form),
        })
          .then(function (r) {
            if (!r.ok) throw new Error('cart');
            return r.json();
          })
          .then(function (datos) {
            ponerTexto(textoComprar);
            boton.disabled = false;
            arrancarReserva();
            refrescarContadorCarrito();
            // La respuesta trae la linea recien anadida. Segun la version de
            // la API llega suelta o dentro de `items`.
            var linea = datos && datos.items ? datos.items[0] : datos;
            abrirAnadido(linea, bloque);
          })
          .catch(function () {
            // Si algo falla, dejamos que el navegador haga el envio normal:
            // el usuario nunca se queda sin poder comprar.
            form.dataset.mtListo = '';
            form.submit();
          });
      });
    });
  }

  /* --- Aviso de "anadido al carrito" -------------------------------------- */
  /* Antes de esto, anadir al carrito solo cambiaba el numerito del icono de
     arriba: casi nadie lo veia. Ahora sale un panel que confirma lo anadido y
     ofrece las dos salidas (pagar o ver el carrito). */

  var panelAnadido = null;
  var focoPrevio = null;
  var cerrarLento = null;

  /* Shopify da los precios en centimos y el formato del escaparate como
     plantilla ({{amount}} €). Lo montamos aqui para no depender de ningun
     guion de Dawn. */
  function mtDinero(centimos, formato) {
    var valor = (centimos || 0) / 100;

    function pintar(decimales, miles, coma) {
      var texto = valor.toFixed(decimales);
      var trozos = texto.split('.');
      var entero = trozos[0].replace(/\B(?=(\d{3})+(?!\d))/g, miles);
      return decimales > 0 ? entero + coma + trozos[1] : entero;
    }

    var plantilla = (formato || '').replace(/<[^>]*>/g, '') || '{{amount}}';
    return plantilla.replace(/\{\{\s*(\w+)\s*\}\}/, function (todo, clave) {
      switch (clave) {
        case 'amount_no_decimals':
          return pintar(0, ',', '.');
        case 'amount_with_comma_separator':
          return pintar(2, '.', ',');
        case 'amount_no_decimals_with_comma_separator':
          return pintar(0, '.', ',');
        case 'amount_with_space_separator':
          return pintar(2, ' ', ',');
        case 'amount_no_decimals_with_space_separator':
          return pintar(0, ' ', ',');
        case 'amount_with_apostrophe_separator':
          return pintar(2, "'", '.');
        default:
          return pintar(2, ',', '.');
      }
    });
  }

  /* El color y la talla se leen de los selectores de la pagina, NO del
     `variant_title` que devuelve Shopify: ese viene en ingles (Pink / M) y la
     tienda los ensena traducidos. */
  function textoVariante(bloque) {
    var partes = [];
    if (!bloque) return '';
    bloque.querySelectorAll('.mt-opcion').forEach(function (opcion) {
      var marcado = opcion.querySelector('input[data-mt-opcion]:checked');
      if (!marcado) return;
      var etiqueta = opcion.querySelector('label[for="' + marcado.id + '"]');
      var nombre = opcion.querySelector('.mt-opcion__nombre');
      var valor = etiqueta
        ? etiqueta.getAttribute('data-mt-nombre') || etiqueta.textContent
        : marcado.value;
      partes.push((nombre ? nombre.textContent.trim() + ': ' : '') + valor.trim());
    });
    return partes.join(' · ');
  }

  function anchoFoto(url) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=240';
  }

  function cerrarAnadido() {
    if (!panelAnadido || panelAnadido.hidden) return;
    panelAnadido.classList.remove('is-abierto');
    document.body.classList.remove('mt-bloqueada');
    if (cerrarLento) clearTimeout(cerrarLento);
    cerrarLento = setTimeout(function () {
      if (panelAnadido) panelAnadido.hidden = true;
    }, 320);
    // Devolvemos el foco a donde estaba. Si de donde venia no es enfocable
    // (el <body>, por ejemplo), lo dejamos en el boton de compra: si no, se
    // queda dentro de un panel ya oculto.
    var destino = focoPrevio;
    if (!destino || destino === document.body || !destino.focus) {
      destino = document.querySelector('[data-mt-producto] [data-mt-boton]');
    }
    if (destino && destino.focus) destino.focus();
    focoPrevio = null;
  }

  function abrirAnadido(linea, bloque) {
    var panel = panelAnadido;
    if (!panel) return;

    var formato = panel.getAttribute('data-moneda') || '';
    var foto = panel.querySelector('[data-mt-anadido-foto]');
    var nombre = panel.querySelector('[data-mt-anadido-nombre]');
    var variante = panel.querySelector('[data-mt-anadido-variante]');
    var precio = panel.querySelector('[data-mt-anadido-precio]');

    if (nombre) nombre.textContent = (linea && (linea.product_title || linea.title)) || '';

    if (variante) {
      var detalle = textoVariante(bloque);
      var unidades = linea && linea.quantity > 1 ? linea.quantity : 0;
      if (unidades) {
        var plantillaUds = panel.getAttribute('data-texto-uds') || '[n] unidades';
        var textoUds = plantillaUds.replace('[n]', unidades);
        detalle = detalle ? detalle + ' · ' + textoUds : textoUds;
      }
      variante.textContent = detalle;
      variante.hidden = detalle === '';
    }

    if (precio) {
      var importe = linea && (linea.final_line_price != null ? linea.final_line_price : linea.line_price);
      precio.textContent = mtDinero(importe, formato);
    }

    if (foto) {
      var url = (linea && (linea.image || linea.featured_image)) || '';
      if (url && url.src) url = url.src;
      if (!url) {
        var principal = bloque && bloque.querySelector('.mt-galeria__principal img');
        url = principal ? principal.currentSrc || principal.src : '';
      }
      if (url) {
        foto.src = anchoFoto(url);
        foto.alt = '';
        foto.hidden = false;
      } else {
        foto.removeAttribute('src');
        foto.hidden = true;
      }
    }

    panel.hidden = false;
    if (cerrarLento) clearTimeout(cerrarLento);
    focoPrevio = document.activeElement;
    // Un fotograma de margen: si se pinta y se anima a la vez, no hay
    // transicion y el panel aparece de golpe.
    setTimeout(function () {
      panel.classList.add('is-abierto');
      document.body.classList.add('mt-bloqueada');
      var primero = panel.querySelector('.mt-btn');
      if (primero) primero.focus();
    }, 20);
  }

  function pintarCarritoEnAviso(carrito) {
    if (!panelAnadido || !carrito) return;
    var formato = panelAnadido.getAttribute('data-moneda') || '';
    var total = panelAnadido.querySelector('[data-mt-anadido-total]');
    var cuenta = panelAnadido.querySelector('[data-mt-anadido-cuenta]');
    var nudge = panelAnadido.querySelector('[data-mt-anadido-nudge]');
    if (total) total.textContent = mtDinero(carrito.total_price, formato);
    if (cuenta) cuenta.textContent = '(' + carrito.item_count + ')';
    // El 2x15% es un descuento automatico REAL de la tienda: solo tiene
    // sentido ensenarlo cuando aun falta la segunda prenda.
    if (nudge) nudge.hidden = carrito.item_count !== 1;
  }

  function initAnadido(raiz) {
    var nuevo = (raiz || document).querySelector('[data-mt-anadido]');
    if (!nuevo || nuevo === panelAnadido) return;

    // El editor recarga la seccion entera: fuera el panel de la pasada anterior.
    document.querySelectorAll('[data-mt-anadido]').forEach(function (viejo) {
      if (viejo !== nuevo && viejo.parentNode) viejo.parentNode.removeChild(viejo);
    });

    // Se cuelga del body a proposito: dentro de la seccion, cualquier ancestro
    // con `transform` haria que `position: fixed` se anclara a el y no a la
    // pantalla, y el panel se quedaria a medio camino.
    document.body.appendChild(nuevo);
    panelAnadido = nuevo;

    nuevo.querySelectorAll('[data-mt-anadido-cerrar]').forEach(function (boton) {
      boton.addEventListener('click', cerrarAnadido);
    });

    if (!document.body.dataset.mtAnadidoListo) {
      document.body.dataset.mtAnadidoListo = '1';
      document.addEventListener('keydown', function (evento) {
        if (evento.key === 'Escape') cerrarAnadido();
      });
      document.addEventListener('mt:carrito', function (evento) {
        pintarCarritoEnAviso(evento.detail);
      });
    }
  }

  /* --- Oferta de volumen (pone la cantidad de golpe) ---------------------- */

  function initVolumen(raiz) {
    var botones = (raiz || document).querySelectorAll('[data-mt-volumen]');
    botones.forEach(function (boton) {
      if (boton.dataset.mtListo === '1') return;
      boton.dataset.mtListo = '1';
      boton.addEventListener('click', function () {
        var bloque = boton.closest('[data-mt-producto]') || document;
        var input = bloque.querySelector('[data-mt-cantidad] input');
        var cantidad = parseInt(boton.getAttribute('data-cantidad'), 10) || 2;
        if (input) {
          input.value = cantidad;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
        var comprar = bloque.querySelector('[data-mt-boton]');
        if (comprar) comprar.focus();
      });
    });
  }

  /* --- Botón fijo en móvil ------------------------------------------------ */

  function initSticky() {
    var sticky = document.querySelector('[data-mt-sticky]');
    if (!sticky || sticky.dataset.mtListo === '1') return;
    sticky.dataset.mtListo = '1';

    var boton = sticky.querySelector('[data-mt-sticky-boton]');
    var real = document.querySelector('[data-mt-producto] [data-mt-boton]');

    if (boton && real) {
      boton.addEventListener('click', function () {
        real.click();
      });
    }

    if (!real) return;

    // Aparece cuando el boton de verdad ya ha salido por arriba de la pantalla.
    // Limitamos por tiempo, NO con un cerrojo + requestAnimationFrame: si el
    // navegador se salta un fotograma (pestaña en segundo plano, ahorro de
    // energia), el cerrojo se queda puesto y el boton no vuelve a aparecer.
    var ultimo = 0;

    function revisar() {
      ultimo = Date.now();
      var fuera = real.getBoundingClientRect().bottom < 0;
      sticky.classList.toggle('is-visible', fuera);
      sticky.setAttribute('aria-hidden', fuera ? 'false' : 'true');
    }

    function alScroll() {
      if (Date.now() - ultimo < 100) return;
      revisar();
    }

    window.addEventListener('scroll', alScroll, { passive: true });
    window.addEventListener('resize', alScroll, { passive: true });
    revisar();
  }

  /* --- Guía de tallas: el enlace abre el desplegable ----------------------- */

  function initGuiaTallas(raiz) {
    var enlaces = (raiz || document).querySelectorAll('[data-mt-abrir-tallas]');
    enlaces.forEach(function (enlace) {
      if (enlace.dataset.mtListo === '1') return;
      enlace.dataset.mtListo = '1';
      enlace.addEventListener('click', function () {
        var item = document.querySelector('[data-mt-tallas]');
        if (!item) return;
        var boton = item.querySelector('.mt-faq__boton');
        if (boton && !item.classList.contains('is-abierto')) boton.click();
        item.scrollIntoView({ behavior: sinMovimiento ? 'auto' : 'smooth', block: 'center' });
      });
    });
  }

  /* --- Corte de envío ------------------------------------------------------ */
  /* Cuenta atras REAL contra el reloj del visitante corregido al horario del
     almacen. Si ya pasó la hora, o es fin de semana, se dice la verdad. */

  function initCorte(raiz) {
    var avisos = (raiz || document).querySelectorAll('[data-mt-corte]');
    avisos.forEach(function (aviso) {
      if (aviso.dataset.mtListo === '1') return;
      aviso.dataset.mtListo = '1';

      var hora = parseInt(aviso.getAttribute('data-hora'), 10);
      var desfase = parseInt(aviso.getAttribute('data-desfase'), 10) || 0;
      var plantilla = aviso.getAttribute('data-texto') || '';
      var fuera = aviso.getAttribute('data-texto-fuera') || '';
      var etiqueta = aviso.querySelector('[data-mt-corte-texto]');
      if (isNaN(hora) || !etiqueta) return;

      function pintar() {
        var ahora = new Date(Date.now() + desfase * 3600000);
        var dia = ahora.getDay(); // 0 domingo, 6 sabado
        var finDeSemana = dia === 0 || dia === 6;

        var corte = new Date(ahora);
        corte.setHours(hora, 0, 0, 0);
        var restante = Math.floor((corte - ahora) / 1000);

        if (finDeSemana || restante <= 0) {
          etiqueta.textContent = fuera;
          aviso.hidden = fuera === '';
          return;
        }

        var h = Math.floor(restante / 3600);
        var m = Math.floor((restante % 3600) / 60);
        var reloj = h > 0 ? h + ' h ' + m + ' min' : m + ' min';
        etiqueta.innerHTML = plantilla.replace('[reloj]', '<strong>' + reloj + '</strong>');
        aviso.hidden = false;
      }

      pintar();
      setInterval(pintar, 30000);
    });
  }

  /* --- Barra de envío gratis ---------------------------------------------- */

  function initEnvio(raiz) {
    var barras = (raiz || document).querySelectorAll('[data-mt-envio]');
    if (!barras.length) return;

    function pintar(carrito) {
      barras.forEach(function (barra) {
        var modo = barra.getAttribute('data-modo') || 'importe';
        // En la cinta el mensaje del carrito sale varias veces (la lista se
        // pinta dos veces y ademas el guion clona la pista entera): hay que
        // escribirlo en TODAS las copias o quedarian desparejadas.
        var etiquetas = barra.querySelectorAll('[data-mt-envio-texto]');
        var progreso = barra.querySelector('[data-mt-envio-progreso]');

        // Mensaje fijo: no depende del carrito
        if (modo === 'fijo') {
          var fijo = barra.getAttribute('data-texto-fijo') || '';
          etiquetas.forEach(function (e) { e.textContent = fijo; });
          return;
        }

        var actual;
        var meta;
        var relleno;

        if (modo === 'unidades') {
          // Cuenta prendas en el carrito hacia la oferta de volumen
          meta = parseInt(barra.getAttribute('data-unidades'), 10) || 2;
          actual = carrito ? carrito.item_count : 0;
          var faltanUds = Math.max(0, meta - actual);
          relleno = ['[n]', String(faltanUds)];
          // Carrito vacío, "falta 1" y "faltan varias" se dicen distinto
          if (actual === 0) {
            barra.dataset.mtPlantilla = barra.getAttribute('data-texto-vacio') || '';
          } else if (faltanUds === 1) {
            barra.dataset.mtPlantilla = barra.getAttribute('data-texto-uno') || '';
          } else {
            barra.dataset.mtPlantilla = '';
          }
        } else {
          barra.dataset.mtPlantilla = '';
        }

        if (modo !== 'unidades') {
          meta = parseInt(barra.getAttribute('data-minimo'), 10) || 0;
          if (!meta) return;
          actual = carrito ? carrito.total_price : 0;
          relleno = ['[importe]', formatearDinero(Math.max(0, meta - actual), barra)];
        }

        var cumplido = actual >= meta;
        var plantilla = cumplido
          ? barra.getAttribute('data-texto-logrado')
          : barra.dataset.mtPlantilla || barra.getAttribute('data-texto-falta');

        var html = (plantilla || '').replace(
          relleno[0],
          '<strong>' + relleno[1] + '</strong>'
        );
        etiquetas.forEach(function (e) { e.innerHTML = html; });
        if (progreso) {
          progreso.style.width = Math.min(100, Math.round((actual / meta) * 100)) + '%';
        }
      });
    }

    function formatearDinero(centimos, barra) {
      var simbolo = barra.getAttribute('data-moneda') || '€';
      var valor = (centimos / 100).toFixed(2).replace('.', ',');
      return valor + ' ' + simbolo;
    }

    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js')
      .then(function (r) { return r.json(); })
      .then(pintar)
      .catch(function () { pintar(null); });

    document.addEventListener('mt:carrito', function (e) {
      pintar(e.detail);
    });
  }

  /* --- Barra de anuncio rotatoria ---------------------------------------- */

  function initAnuncio(raiz) {
    var pistas = (raiz || document).querySelectorAll('[data-mt-anuncio]');
    if (!pistas.length) return;

    pistas.forEach(function (pista) {
      // El editor recarga secciones sueltas: hay que matar el temporizador
      // anterior o se acumulan y el mensaje empieza a parpadear.
      if (pista.mtTemporizador) {
        clearInterval(pista.mtTemporizador);
        pista.mtTemporizador = null;
      }

      var slides = pista.querySelectorAll('[data-mt-anuncio-slide]');
      var barra = pista.closest('[data-mt-envio]');
      if (slides.length < 2) {
        if (barra) barra.classList.add('is-dinamica');
        return;
      }

      var intervalo = parseInt(pista.getAttribute('data-intervalo'), 10) || 5000;
      var actual = 0;
      var parada = false;

      function mostrar(indice, animar) {
        slides.forEach(function (slide, i) {
          var activa = i === indice;
          var eraActiva = slide.classList.contains('is-activa');
          // El que se va sale hacia arriba; el que entra sube desde abajo.
          // Se limpia en el siguiente cambio (entonces ya esta invisible).
          slide.classList.remove('is-saliente');
          if (animar && eraActiva && !activa) {
            slide.classList.add('is-saliente');
          }
          slide.classList.toggle('is-activa', activa);
          if (activa) {
            slide.removeAttribute('aria-hidden');
          } else {
            slide.setAttribute('aria-hidden', 'true');
          }
        });
        // La barra de progreso solo acompana al mensaje del carrito.
        if (barra) {
          barra.classList.toggle(
            'is-dinamica',
            slides[indice].hasAttribute('data-mt-dinamica')
          );
        }
      }

      function avanzar() {
        if (parada || document.hidden) return;
        actual = (actual + 1) % slides.length;
        mostrar(actual, true);
      }

      mostrar(0, false);
      pista.mtTemporizador = setInterval(avanzar, intervalo);

      // Se detiene al pasar el raton o al tabular dentro: si alguien esta
      // leyendo el mensaje, cambiarselo de golpe es molesto.
      ['mouseenter', 'focusin'].forEach(function (evento) {
        pista.addEventListener(evento, function () { parada = true; });
      });
      ['mouseleave', 'focusout'].forEach(function (evento) {
        pista.addEventListener(evento, function () { parada = false; });
      });
    });
  }

  /* --- Vestido estrella de la portada ------------------------------------ */

  function initEstrella(raiz) {
    var bloques = (raiz || document).querySelectorAll('[data-mt-estrella]');
    if (!bloques.length) return;

    bloques.forEach(function (bloque) {
      var grande = bloque.querySelector('[data-mt-estrella-grande]');
      var minis = bloque.querySelectorAll('[data-mt-estrella-mini]');
      if (!grande || !minis.length) return;

      minis.forEach(function (mini) {
        if (mini.dataset.mtListo === '1') return;
        mini.dataset.mtListo = '1';

        mini.addEventListener('click', function () {
          var src = mini.getAttribute('data-src');
          if (!src || grande.getAttribute('src') === src) return;

          minis.forEach(function (otro) {
            otro.classList.toggle('is-activa', otro === mini);
          });

          cambiarFoto(
            grande,
            src,
            mini.getAttribute('data-srcset') || '',
            mini.getAttribute('data-alt') || ''
          );
        });
      });

      conectarFlechas(bloque, '[data-mt-estrella-flecha]', null, minis);
    });
  }

  /* --- Arranque ---------------------------------------------------------- */

  function iniciarTodo(raiz) {
    initReveals(raiz);
    initEstrella(raiz);
    initMarquesinas(raiz);
    initFaq(raiz);
    initGaleria(raiz);
    initVariantes(raiz);
    initCantidad(raiz);
    initAnadido(raiz);
    initCompra(raiz);
    initVolumen(raiz);
    initGuiaTallas(raiz);
    initEnvio(raiz);
    initAnuncio(raiz);
    initCorte(raiz);
  }

  function arrancar() {
    iniciarTodo(document);
    initParallax();
    initSticky();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }

  // El editor de Shopify recarga secciones sueltas: hay que re-inicializarlas.
  document.addEventListener('shopify:section:load', function (evento) {
    iniciarTodo(evento.target);
    initParallax();
    initSticky();
  });
})();
